import { render, staticRenderFns } from "./activitytemplate.vue?vue&type=template&id=316555a8&scoped=true"
import script from "./activitytemplate.vue?vue&type=script&lang=js"
export * from "./activitytemplate.vue?vue&type=script&lang=js"
import style0 from "./activitytemplate.vue?vue&type=style&index=0&id=316555a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316555a8",
  null
  
)

export default component.exports